"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineReducers = combineReducers;
exports.getDotStrPath = getDotStrPath;
exports.getSlashStrPath = getSlashStrPath;
exports.pathToArr = pathToArr;
exports.preserveValuesFromState = preserveValuesFromState;
exports.recursiveUnset = recursiveUnset;

var _unset2 = _interopRequireDefault(require("lodash/fp/unset"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _size2 = _interopRequireDefault(require("lodash/size"));

var _get2 = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pathToArr(path) {
  return path ? path.split(/\//).filter(p => !!p) : [];
}

function getSlashStrPath(path) {
  return pathToArr(path).join('/');
}

function getDotStrPath(path) {
  return pathToArr(path).join('.');
}

function combineReducers(reducers) {
  return function () {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let action = arguments.length > 1 ? arguments[1] : undefined;
    return Object.keys(reducers).reduce((nextState, key) => {
      nextState[key] = reducers[key](state[key], action);
      return nextState;
    }, {});
  };
}

function preserveValuesFromState(state, preserveSetting, nextState) {
  if (typeof preserveSetting === 'function') {
    return preserveSetting(state, nextState);
  }

  if (preserveSetting === true) {
    return nextState ? { ...state,
      ...nextState
    } : state;
  }

  if (Array.isArray(preserveSetting)) {
    return (0, _pick2.default)(state, preserveSetting);
  }

  throw new Error('Invalid preserve parameter. It must be an Object or an Array');
}

function recursiveUnset(path, obj) {
  let isRecursiveCall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!path) {
    return obj;
  }

  if ((0, _size2.default)((0, _get2.default)(obj, path)) > 0 && isRecursiveCall) {
    return obj;
  }

  const objectWithRemovedKey = (0, _unset2.default)(path, obj);
  const newPath = path.match(/\./) ? path.replace(/\.[^.]*$/, '') : '';
  return recursiveUnset(newPath, objectWithRemovedKey, true);
}